import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {playButtonTap} from './PlaySounds';
import TopBar from './GameTopBar';
import {setGameScreenNumber,setCurrentIndex} from '../actions/commonActions';

class GameAnswerScreen extends Component {

  showQuestionScreen = () => {
    playButtonTap();
    var newIndex = this.props.currentIndex+1;
    if(newIndex >= this.props.mythsAndFacts.length){
      this.props.history.push('/resultscreen');
    }else{
      this.props.setCurrentIndex(newIndex);
      this.props.setGameScreenNumber(1,1);
    }
    
  };
    

    render() {
      var direction = "";
      var sourceTitle = "";
      var question = this.props.currentQuestion.statement;
      var answer = this.props.currentQuestion.explanation;
      
      var linkClass = "";
     
      if(this.props.language === "en"){
          //question = "question goes here yaha pe question hoga aure batao kia hall hain sab teek hain ";
          //answer = "question goes here yaha pe question hoga aure batao kia hall hain sab teek hain ";
           sourceTitle = "Source: "
           direction = "ltr";
      }else if(this.props.language === "ur"){

        if(this.props.currentQuestion.id === 54){
          answer = <div> ہنگامی انتباہی علامات میں شامل ہیں:
		  <br/>
		  سانس لینے میں دشواری یا سانس کی قلت 
		  <br/>
		  سینے میں مستقل درد یا دباؤ 
		  <br/>
		  نیلے ہونٹ یا چہرہ </div>;
        }

        if(this.props.currentQuestion.id === 17){
          answer = <div>
            کورونا وائرس ایسے لوگوں سے بھی پھیل سکتا ہے جو بظاھر بیمار نظرنہ آرہے ہوں۔ ایسے لوگوں کو 'asymptomatic'  یا  <br/> 'pre-symptomatic' کہا جاتا ہے
          </div>
        }

        //question = "question goes here yaha pe question hoga aure batao kia hall hain sab teek hain ";
        //answer = "question goes here yaha pe question hoga aure batao kia hall hain sab teek hain ";
        sourceTitle = "Source: "
          direction = "rtl";
      }

      if(localStorage.getItem('game_mode') === "time"){
        linkClass = "hidden";
      }
    var sourceText = <div>{sourceTitle}{this.props.currentQuestion.source}<br/> <a href = {this.props.currentQuestion.url} target ="_blank" rel="noopener noreferrer" className = {linkClass}>{this.props.currentQuestion.url}</a></div>;

            return(
                <div className = "screen_background">
                  <div>
                    <TopBar/>
                  </div>
                  <div dir={direction} className = "question_popup answer_page_question">
                    {question}
                  </div>
                  <div className = "answer_popup">
                    <div  className= "scroll_div answer_scroll_div">
                      <div dir={direction}>
                         {answer}
                      </div> 
                    </div>
                    <div className = "answer_source">
                      {sourceText}
                    </div>
                  </div>
                  <img src={"/game-skins/build-rev23-PfhLPVSBF/images_"+this.props.language+"/btn_next.png"} alt="" className="button" onClick = {this.showQuestionScreen}/>
                </div>
            )
    }
}

GameAnswerScreen.propTypes = {
  language:PropTypes.string.isRequired,
  currentIndex:PropTypes.number.isRequired,
  mythsAndFacts:PropTypes.array.isRequired,
  currentQuestion:PropTypes.object.isRequired
}
const mapStateToProps = state =>({
  language: localStorage.getItem('language',"en"),
  currentIndex:state.config.currentIndex,
  mythsAndFacts:state.localData.mythsAndFacts,
  currentQuestion:state.config.currentQuestion
});
export default withRouter(connect(mapStateToProps,{setGameScreenNumber,setCurrentIndex})(GameAnswerScreen));
//export default withRouter(IntroScreen);



// WEBPACK FOOTER //
// ./src/components/GameAnswerScreen.js